import {
  TAX_SETTINGS_INDEX_REQUESTED,
  TAX_SETTINGS_INDEX_SUCCESS,
  TAX_SETTINGS_INDEX_FAILURE,

  TAX_SETTING_CREATE_REQUESTED,
  TAX_SETTING_CREATE_SUCCESS,
  TAX_SETTING_CREATE_FAILURE,

  TAX_SETTING_UPDATE_REQUESTED,
  TAX_SETTING_UPDATE_SUCCESS,
  TAX_SETTING_UPDATE_FAILURE,

  TAX_SETTING_DELETE_REQUESTED,
  TAX_SETTING_DELETE_SUCCESS,
  TAX_SETTING_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  taxSettings: [],
  errors: null
};

const taxSettings = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case TAX_SETTINGS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        taxSettings: [],
        status: 'requesting',
        errors: null,
      });

    case TAX_SETTINGS_INDEX_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'success',
        taxSettings: action.payload.tax_settings,
        errors: null
      });

    case TAX_SETTINGS_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        taxSettings: [],
        errors: 'error here'
      });

    case TAX_SETTING_CREATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case TAX_SETTING_CREATE_SUCCESS:
      newState.isUpdating = false;
      newState.taxSettings.push(action.taxSetting.taxSetting);
      return newState;

    case TAX_SETTING_CREATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to create tax setting';
      return newState


    case TAX_SETTING_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case TAX_SETTING_UPDATE_SUCCESS:
      newState.isUpdating = false;
      let toUpdate = newState.taxSettings.findIndex(tax => tax.id === action.taxSetting.taxSetting.id);
      newState.taxSettings[toUpdate] = action.taxSetting.taxSetting;
      return newState;

    case TAX_SETTING_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to update tax setting';
      return newState;



    case TAX_SETTING_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.taxSettings = newState.taxSettings.filter(tax => tax.id !== action.taxSettingId);
      newState.errors = null;
      return newState;

    case TAX_SETTING_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case TAX_SETTING_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to delete tax setting';
      return newState;

    default:
      return state;
  }
}

export default taxSettings;